import { initialState, ServicesDueState, servicesDueAdapter } from './services-due.interfaces';
import * as fromServicesDue from './services-due.actions';
export function reducer(state = initialState, action: fromServicesDue.ServicesDueAction): ServicesDueState {
  switch (action.type) {
    case fromServicesDue.GET_SERVICES_DUE_FROM_SERVER: {
      return { ...state, loaded: false, error: null };
    }
    case fromServicesDue.GET_SERVICES_DUE_FROM_SERVER_SUCCESS: {
      return {
        ...servicesDueAdapter.addMany(action.payload.servicesDue, state),
        loaded: true,
        error: null,
      };
    }
    case fromServicesDue.GET_SERVICES_DUE_FROM_SERVER_FAILURE: {
      return { ...state, error: String(action.payload.error) };
    }
    case fromServicesDue.GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER: {
      return { ...state, roHistoryLoading: true, roHistoryError: null };
    }
    case fromServicesDue.GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER_FAILURE: {
      return { ...state, roHistoryError: action.payload.error };
    }
    case fromServicesDue.GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER_SUCCESS: {
      return { ...state, roHistory: action.payload.roHistory, roHistoryLoading: false };
    }
    case fromServicesDue.CLEAR_SERVICES_DUE_IN_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
